module.exports = __webpack_public_path__ + "img/p4.9aad26cf.png";